import { useState } from 'react';
import { formatPhoneNumber, validatePhoneUS } from 'helpers/signup.helpers';
import { trimPhoneNumber } from 'helpers/phone.helper';

function usePhoneNumberInput(
  phoneNumber,
  ignoreInitialError,
  phoneType = 'mobile',
) {
  const initPhoneNumber = trimPhoneNumber(phoneNumber);
  let initError = getError(initPhoneNumber);
  const initDisplay = getFormattedPhoneUS(initPhoneNumber);
  if (ignoreInitialError) {
    initError = false;
  }

  const [contactPhoneNumber, setContactPhoneNumber] = useState({
    value: initPhoneNumber,
    error: initError,
    displayValue: initDisplay,
  });

  const [type, setType] = useState({
    type: phoneType,
  });

  function getError(value) {
    return validatePhoneUS(value);
  }

  function isFullLength(value) {
    if (!value) {
      return false;
    }
    return value.length === 10 ? true : false;
  }

  function getFormattedPhoneUS(value) {
    const trimmed = trimPhoneNumber(value);
    return isFullLength(trimmed) ? formatPhoneNumber(trimmed) : trimmed;
  }

  return {
    contactPhoneNumber,
    type,
    update(value) {
      const trimmedPhoneNumber = trimPhoneNumber(value);
      const error = getError(trimmedPhoneNumber);
      return setContactPhoneNumber({
        value: trimmedPhoneNumber,
        error: error,
        displayValue: getFormattedPhoneUS(trimmedPhoneNumber),
      });
    },
    reset() {
      return setContactPhoneNumber({
        value: '',
        error: false,
        displayValue: '',
      });
    },
    trimPhoneNumberUS(value) {
      return trimPhoneNumber(value);
    },
    updateType(value) {
      setType({
        type: value,
      });
    },
  };
}

export default usePhoneNumberInput;
